//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			filters: ""
		}
	},
	components: {
		ResponsiveImageStrapi,
	},
	computed: {
		posts() {
			// const re = this.$store.getters.cmsdata;
			// console.log('d index: ', re.home)
			// return this.$store.getters.posts
			const posts = this.$store.getters.posts;
			let categories = "";
			if (this.filters){
				categories = this.filters;
			}
			if (categories !== ""){
				const final = Object.entries(posts).filter((post) => { 
					return post[1].categories.map( (item) => item.id).includes(categories);
				});
				return Object.fromEntries(final);
			} else {
				return this.$store.getters.posts;
			}
		},
		categories() {
			return this.$store.getters.categories
		},
		posts_sorted() {
			const values = Object.values(this.posts)
			return values.sort((a, b) => b.published_at - a.published_at).reverse() // change order by swapping -
		},
	},
	async asyncData({
		params,
		error,
		store
	}) {
		// console.log("async page _slug: ", params.slug);
		try {
			await store.dispatch('getPostsAll')
		} catch (e) {
			error({
				statusCode: e.statusCode,
				message: e.message
			})
		}
	},
	methods: {
		filterIncategory(cat) {
			console.log("onfilter: ", cat)
			this.filters = cat;
		},
		getArray(array) {
			return array.map( (item) => item.id);
		},
	}
}

